module.exports = __webpack_public_path__ + "img/emoji.3f7d6588.svg";